import { Avatar, AvatarImage, AvatarFallback } from "../ui/avatar";
import { Shield } from "lucide-react";
import { TIER_COLORS, TIER_GLOW, BADGE_CORNER_CLASSES } from "../../lib/gauntlets";

const MERCHANT_BADGE_URL = "https://static.prod-images.emergentagent.com/jobs/4aedbd9c-cc9b-4c85-b42d-35c258d0324d/images/4b2d03ddb671b65892072c67ab8a4e58d592638ea1a2fa213448b1da3401e41f.jpeg";

const SIZES = { sm: "w-8 h-8", md: "w-11 h-11", lg: "w-16 h-16" };
const BADGE_SIZES = { sm: "w-3.5 h-3.5 -bottom-0.5 -right-0.5", md: "w-4.5 h-4.5 -bottom-0.5 -right-0.5", lg: "w-6 h-6 -bottom-1 -right-1" };
const GAUNTLET_BADGE_SIZES = { sm: "w-3.5 h-3.5", md: "w-4.5 h-4.5", lg: "w-6 h-6" };

// Shared avatar used across Knights Fee (feed, profile cards, nav) — shows a glowing gold
// coin-bag badge in the corner for Merchants (Bazaar phase sets `is_merchant`; harmless/off
// for everyone until then), plus an optional Gauntlet tier badge in whichever corner the
// Knight picked for themselves (see gauntlet_router.py's badge-display endpoint).
export function KfAvatar({ name, avatarUrl, isMerchant, size = "md", gauntletBadge }) {
  return (
    <div className={`relative shrink-0 ${SIZES[size]}`} data-testid="kf-avatar">
      <Avatar className={`${SIZES[size]} border border-white/10`}>
        <AvatarImage src={avatarUrl} alt={name} />
        <AvatarFallback className="bg-[#322216] text-[#D4AF37] font-display">
          {(name || "K").charAt(0).toUpperCase()}
        </AvatarFallback>
      </Avatar>
      {isMerchant && (
        <img
          src={MERCHANT_BADGE_URL}
          alt="Merchant"
          title="Merchant of the Bazaar"
          data-testid="kf-merchant-badge"
          className={`absolute rounded-full ${BADGE_SIZES[size]}`}
        />
      )}
      {gauntletBadge?.tier && (
        <div
          title={`${gauntletBadge.tier.label} — ${gauntletBadge.label || "Gauntlet"}`}
          data-testid="kf-gauntlet-badge"
          className={`absolute rounded-full border-2 border-[#151613] flex items-center justify-center ${GAUNTLET_BADGE_SIZES[size]} ${BADGE_CORNER_CLASSES[gauntletBadge.corner] || BADGE_CORNER_CLASSES["top-right"]} ${TIER_GLOW[gauntletBadge.tier.key] || ""}`}
          style={{ backgroundColor: TIER_COLORS[gauntletBadge.tier.key] || "#888" }}
        >
          <Shield className="w-[65%] h-[65%] text-black/70" />
        </div>
      )}
    </div>
  );
}

